<!-- AddNewLinkSidebar.vue -->
<template>
  <div>
    <b-modal
      id="add-new-category-sidebar"
      :visible="isAddNewCategorySidebarActive"
      size="lg"
      :title="popupTitle"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:is-add-new-category-sidebar-active', val)"
    >
      <template #default="{ hide }">
        <validation-observer ref="refFormObserver" v-slot="{ handleSubmit }">
          <b-form
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
            id="linkForm"
          >
            <validation-provider
                v-slot="validationContext"
                name="Mail adı"
                rules="required"
            >
                <b-form-group
                label="Mail adı"
                label-for="campaign_name"
                >
                <b-form-input
                    id="campaign_name"
                    v-model="linkData.campaign_name"
                    :state="getValidationState(validationContext)"
                    trim
                />
                <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
                </b-form-group>
            </validation-provider>
            
            <validation-provider
                v-slot="validationContext"
                name="Açıklama"
            >
                <b-form-group
                label="Açıklama"
                label-for="description"
                >
                <b-form-textarea
                    id="description"
                    v-model="linkData.description"
                    :state="getValidationState(validationContext)"
                    trim
                />
                <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
                </b-form-group>
            </validation-provider>

            <b-row>
        </b-row>

        
            <!-- Tarihler ve oranlar sadece profil fenomeni değilse -->
            <template>

                <div class="d-flex justify-content-between align-items-center">
                <label for="linkStatus">Kategori durumu</label>
                <b-form-checkbox
                    id="linkStatus"
                    v-model="linkData.status"
                    switch
                />
                </div>
            </template>
          </b-form>
        </validation-observer>


      </template>
      <template #modal-footer="{ hide }">
        <div class="d-flex mt-2 justify-content-between col-12">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            @click="hide"
            :disabled="addLoading"
          >
            Vazgeç {{ type }}
          </b-button>
          <div class="d-flex">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              :disabled="!selectType || addLoading"
              class="ml-2"
              @click="$refs.refFormObserver.validate().then(success => { if (success) { onSubmit(); } })"
            >
              <b-spinner small v-if="addLoading" class="mr-1"/>
              {{ addLoading ? 'İşlem Yapılıyor...' : (editingCategory ? 'Kaydet' : 'Ekle') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormFile, BFormTextarea, BFormInvalidFeedback,
  BButton, BSpinner, BInputGroup, BInputGroupAppend, BFormCheckbox, BFormDatepicker, BFormTimepicker, BCard, BRow, BCol,
  BFormRadioGroup, BFormRadio
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref, computed, watch, onMounted  } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import axiosIns from '@/axios'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import { useRouter } from '@core/utils/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Swal from 'sweetalert2'
export default {
  components: {
    BModal, BForm, BFormGroup, BFormInput, BFormFile, BFormTextarea, BFormInvalidFeedback,
    BButton, BSpinner, BInputGroup, BInputGroupAppend, BFormCheckbox, BFormDatepicker, BFormTimepicker, BCard, BRow, BCol,
    ValidationProvider, ValidationObserver, vSelect, BFormRadioGroup, BFormRadio
  },
  directives: {
    Ripple,
    Swal
  },
  props: {
    isAddNewCategorySidebarActive: { type: Boolean, required: true },
    editingCategory: { type: Object, default: null },
    type: { type: Number, default: null },
    platform: { type: Number, default: null },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const selectType = ref(false)
    const selectedType = ref(null)
    const addLoading = ref(false)

    const startDate = ref({
      date: new Date().toISOString().substr(0, 10),
      hours: '00:00:00'
    })
    const endDate = ref({
      date: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().substr(0, 10),
      hours: '00:00:00'
    })

    const blankLink = {
      type: props.type !== null ? props.type : null,
      campaign_name: '',
      status: true,
      description: null
    }

    const linkData = ref({ ...blankLink })

    const { route } = useRouter()
    if (props.type!=null) {
      changeType(props.type)
    }

    const popupTitle = computed(() => {
      return "Kategori Oluştur"
    })
    
    function changeType(role) {
      linkData.value = { ...blankLink }
      selectedType.value = role
      selectType.value = true
    }

    function updateLinkData(data) {
      linkData.value = { ...linkData.value, ...data }
    }

    function getValidationState(context) {
      if (context) return context.validated ? !context.invalid : null
      return null
    }

    const formatDateTime = (date, time) => {
      const combinedDateTime = new Date(`${date}T${time}.000Z`);
      return combinedDateTime.toISOString();
    };

    watch(() => props.editingCategory, (newData) => {
      linkData.value = {
        campaign_name: props.editingCategory.campaign_name || '',
        description: props.editingCategory.description || '',
        status: props.editingCategory.status !== undefined ? props.editingCategory.status : true,
        type: props.editingCategory.type || null,
        id: props.editingCategory.id || null,
      }
      
    });

    const onSubmit = () => {
      if (addLoading.value) return;
      addLoading.value = true

      let requestData = { 
        ...linkData.value
      };
      
      let requestConfig = {
        method: props.editingCategory ? 'put' : 'post'
      };

      axiosIns({
        url: '/link/category',
        data: requestData,
        ...requestConfig
      })
        .then((response) => {
          if (response.data.success) {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'CheckCircleIcon',
                variant: 'success',
                title: response.data.message,
              },
            })
            emit('refetch-data')
            emit('save-category')
            emit('update:is-add-new-category-sidebar-active', false)
          } else if (response.data.warning) {
            // Warning durumunda loading'i false yap (finally'de tekrar yapılacak)
            addLoading.value = false
            
            Swal.fire({
              title: 'Uyarı',
              text: response.data.message,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Evet, bu şekilde ekle',
              cancelButtonText: 'Vazgeç',
              customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ml-1',
              },
              buttonsStyling: false,
            }).then(result => {
              if (result.isConfirmed) {
                const newName = `${new Date().toISOString().slice(0,10)} - ${linkData.value.campaign_name}`
                linkData.value.campaign_name = newName
                onSubmit()
              }else{
                addLoading.value = false
                alert(addLoading.value)
              }
            })
            return // finally bloğuna gitmemek için
          } else {
            toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                icon: 'MailIcon',
                variant: 'warning',
                title: response.data.error,
              },
            })
          }
        })
        .catch((error) => {
          toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              icon: 'InfoIcon',
              variant: 'warning',
              title: error.response?.data?.error || 'Bir hata oluştu',
            },
          })
        })
        .finally(() => {
          addLoading.value = false
        })
    }

    const loadPlatforms = (response) => {
      updateLinkData()
    }


    onMounted(async () => {
      // Platform yükleme kaldırıldı
    })

    const {
      refFormObserver,
      resetForm,
    } = formValidation()

    return {
      selectType,
      selectedType,
      changeType,
      linkData,
      onSubmit,
      refFormObserver,
      resetForm,
      addLoading,
      popupTitle,
      updateLinkData,
      getValidationState,
      startDate,
      endDate,
    }
  }
}
</script>